// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import battleMode from "../battleMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class enemy extends cc.Component {

    @property(cc.Node)
    spIcon: cc.Node = null;
    @property(cc.Label)
    lbHp: cc.Label = null;

    protected onLoad() {
    }

    protected start() {
    }

    private m_hp: number;
    private m_maxHp: number;
    private m_game: battleMode;
    private m_eid: number;

    bindData(eid: number, game: battleMode, hp: number) {
        this.m_eid = eid;
        this.m_game = game;
        this.m_maxHp = this.m_hp = hp;
        //
        this.spIcon.angle = 0;
        cc.Tween.stopAllByTarget(this.spIcon);
        cc.tween(this.spIcon)
            .by(1 + Math.random() * 2, {angle: 180})
            .repeatForever()
            .start();
        this.lbHp.string = `${this.m_hp}`;
    }

    getMaxHp() {
        return this.m_maxHp;
    }

    onNetHurt(n: number) {
        this.m_hp = n;
        this.lbHp.string = `${this.m_hp}`;
    }

    getEid() {
        return this.m_eid;
    }

}

























